import { type GifDetails, GiphyControllerService } from '@api'
import { createEffect, createEvent, createStore, sample } from 'effector'

import { handleError } from '@/utils/error'

export const requestGifFx = createEffect({
  name: 'request gif',
  handler: async (gifId: string) => {
    return GiphyControllerService.getGif({ gifId })
  },
})

requestGifFx.fail.watch(({ error, params }) => {
  handleError(error, 'Something went wrong while loading gif', () =>
    requestGifFx(params),
  )
})

export const loadGif = createEvent<string>('load gif')
export const $gif = createStore<GifDetails | null>(null).on(
  requestGifFx.doneData,
  (_, data) => data,
)

sample({
  clock: loadGif,
  source: { data: $gif },
  filter: ({ data }, id) => data?.id !== id,
  fn: (_, id) => id,
  target: requestGifFx,
})
